/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import {
  NbCardModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbInputModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { TreeGridModule } from './pages/trademarks/workspaces/tree-grid/tree-grid.module';
import { SearchesModule } from './pages/trademarks/searches/searches.module';
import { NotificationsModule } from './pages/trademarks/notifications/notifications.module';
import { DataRequestsModule } from './pages/trademarks/data-requests/data-requests.module';
import { DeletionRequestsModule } from './pages/trademarks/deletion-requests/deletion-requests.module';
import { SubscriptionsModule } from './pages/trademarks/subscriptions/subscriptions.module';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    SubscriptionsModule,
    DeletionRequestsModule,
    DataRequestsModule,
    NotificationsModule,
    SearchesModule,
    NbInputModule,
    NbCardModule,
   TreeGridModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
